
<template>
  <div
    v-click-outside="handleClickOutside"
    class="relative flex items-center justify-end cursor-pointer lg:hidden z-50"
    @click="open = !open"
  >
    <div
      v-if="open"
      class="absolute w-64 bg-white shadow top-10 right-0 rounded border z-[100]"
    />

    <template
      v-for="(item, index) in navItems"
      :key="index"
    >
      <CatalyticProjectsButton v-if="item.isCatalytic" />

      <ButtonBannerPlan
        v-else
        :to="{ name: item.route }"
        :text="item.label"
      />
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { ButtonBannerPlan, CatalyticProjectsButton } from '@/components/buttons/index.js';

defineProps({
  navItems: Object,
});

const open = ref(false);

const handleClickOutside = () => {
  open.value = false;
};
</script>

